<template>
    <v-dialog v-model="dialog" max-width="700" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.save_in_folder') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row dense>
                    <v-col cols="6" md="4">
                        <folder-card create-mode @click="showAdminFolders" />
                    </v-col>
                    <v-col cols="6" md="4" v-for="folder in lastFolders" :key="folder.id">
                        <folder-card :folder="folder" :is-active="isActiveFolder(folder)"
                            @click="onSelectFolder(folder)" no-edit />
                    </v-col>
                    <v-col cols="6" md="3" v-for="folder in currentFolders" :key="folder.id">
                        <folder-card :folder="folder" :is-active="isActiveFolder(folder)"
                            @click="onSelectFolder(folder)" no-edit />
                    </v-col>
                    <v-col cols="12" v-if="pageCount > 1">
                        <kimsa-pagination @page="page = $event - 1" :pageCount="pageCount"
                            :total-visible="isMobile ? 5 : 7" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text"
                    :disabled="disabled" @click="save" :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <admin-folders-dialog ref="folders" :type="type" :coach-id="coachId" is-second-dialog />
    </v-dialog>
</template>

<script>
import { db } from "@/utils/Firebase";
import { mapMutations, mapState, mapActions } from "vuex";
import FolderCard from '@/components/common/cards/FolderCard'
import AdminFoldersDialog from '@/components/coach/AdminFoldersDialog.vue';
import KimsaPagination from '@/components/common/KimsaPagination'

export default {
    components: { FolderCard, AdminFoldersDialog, KimsaPagination },
    name: "SaveInFolderDialog",
    props: {
        currentId: {
            type: String,
            default: null,
        },
        defaultFolder: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            folder: null,
            page: 0,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'folders']),
        disabled(vm = this) {
            return (!vm.folder && !vm.defaultFolder) || vm.defaultFolder === vm.folder?.id
        },
        currentFoldersType(vm = this) {
            return vm.folders.filter(folder => folder.type === vm.type) || []
        },
        lastFolders(vm = this) {
            return vm.currentFoldersType.slice(0, 2)
        },
        currentFolders(vm = this) {
            let currentPage = (vm.page * 4) + 2
            return vm.currentFoldersType.slice(currentPage, currentPage + 4)
        },
        pageCount(vm = this) {
            return Math.ceil((vm.currentFoldersType.length - 2) / 4)
        },
        coachId(vm = this) {
            return vm.currentUser?.uid || null
        },
    },
    async mounted() {
        const vm = this
        if (vm.folders.length === 0) await vm.bindFolders(vm.currentUser.uid)
        vm.setDefaults()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        ...mapActions(['bindFolders']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.folder = null
            vm.$emit('cancel')
        },
        onSelectFolder(folder) {
            const vm = this
            if (vm.folder?.id === folder?.id) return vm.folder = null
            vm.folder = folder
        },
        isActiveFolder(folder) {
            const vm = this
            return vm.folder?.id === folder.id
        },
        async save() {
            const vm = this
            vm.loading = true
            await db.collection(vm.type).doc(vm.currentId).update({ folder: vm.folder?.id || null })
            vm.hide()
            vm.loading = false
            vm.toast(vm.$t('common.changes_saved'))
        },
        setDefaults() {
            const vm = this
            if (vm.defaultFolder) vm.folder = vm.currentFoldersType.find(folder => vm.defaultFolder === folder.id) || null
        },
        showAdminFolders() {
            const vm = this
            vm.$refs.folders.show()
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        defaultFolder() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>